import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { useSeo } from "@/hooks/useSeo";
import { animeList, topics } from "@/mocks/anime";

export default function Topic() {
  useSeo(
    "专题合集 - 樱花动漫在线",
    "樱花动漫在线精选动漫专题合集，涵盖必追新番、治愈精选、宏世界观冒险与国创力量等主题，帮你系统性地发掘优质动漫。"
  );

  return (
    <div className="w-full">
      <div className="w-full bg-primary-50 border-b border-primary-100">
        <div className="w-full px-4 md:px-8 py-8 md:py-12">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-600 mb-3 flex-wrap">
            <Link to="/" className="hover:text-primary-700 cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-900 font-medium">专题合集</span>
          </nav>
          <h1 className="text-2xl md:text-4xl font-bold text-foreground-950">精选动漫专题合集</h1>
          <p className="mt-3 text-sm md:text-base text-foreground-700 max-w-3xl leading-relaxed">
            我们为你整理了不同主题的动漫合集，从当季新番到治愈深夜番，从宏大世界观到国创佳作，
            跟着专题一份一份看下去，总有一部会让你心动。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {topics.map((t) => (
              <a
                key={t.id}
                href={`#${t.id}`}
                className="px-3.5 py-1.5 rounded-full bg-background-50 border border-primary-200 text-xs md:text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                {t.title}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-10 md:py-14 flex flex-col gap-14 md:gap-20">
        {topics.map((topic, idx) => {
          const items = topic.animeIds
            .map((aid) => animeList.find((a) => a.id === aid))
            .filter((a): a is (typeof animeList)[number] => Boolean(a));

          return (
            <section key={topic.id} id={topic.id} className="scroll-mt-24">
              <div
                className={`flex flex-col lg:flex-row gap-6 lg:gap-10 ${
                  idx % 2 === 1 ? "lg:flex-row-reverse" : ""
                }`}
              >
                <div className="w-full lg:w-[420px] shrink-0">
                  <div className="w-full aspect-[8/5] rounded-lg overflow-hidden bg-background-100 border border-background-200">
                    <img
                      src={topic.cover}
                      alt={`${topic.title} 专题封面`}
                      title={`${topic.title} 动漫专题合集`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      专题 {String(idx + 1).padStart(2, "0")}
                    </span>
                    <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
                      共 {items.length} 部
                    </span>
                  </div>
                  <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3">
                    {topic.title}
                  </h2>
                  <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                    {topic.intro}
                  </p>
                  <div className="rounded-lg bg-accent-50 border border-accent-100 p-4 mb-5">
                    <p className="text-xs md:text-sm text-foreground-700 leading-relaxed">
                      <i className="ri-lightbulb-line text-accent-600 mr-2"></i>
                      <span className="font-semibold text-foreground-900">推荐理由：</span>
                      {topic.reason}
                    </p>
                  </div>

                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4">
                    {items.map((anime) => (
                      <AnimeCard key={anime.id} anime={anime} showDescription={false} />
                    ))}
                  </div>
                </div>
              </div>
            </section>
          );
        })}
      </div>

      <div className="w-full px-4 md:px-8 pb-4">
        <div className="rounded-lg bg-secondary-50 border border-secondary-100 p-6 md:p-8">
          <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4 flex items-center gap-2">
            <i className="ri-links-line text-secondary-700"></i>
            相关专题导航
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {topics.map((t) => (
              <a
                key={t.id}
                href={`#${t.id}`}
                className="group flex items-center justify-between gap-3 px-4 py-3 rounded-lg bg-background-50 border border-secondary-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 line-clamp-1">
                  {t.title}
                </span>
                <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-600 shrink-0"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}